import * as Yup from 'yup'
const validationSchema = () =>
  Yup.object().shape({
    code: Yup.string().required(),
    remember: Yup.boolean(),
  })

export default validationSchema
